export class CurrentUser {
  access_token: string;
  refresh_token: string;
}